<template>
  <v-card-title
    class="au-card-title pa-0 ma-0"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-icon v-if="icon" class="pr-1">{{ icon }}</v-icon>
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
    <slot></slot>
  </v-card-title>
</template>

<script>
export default {
  name: "TcnAuCardTitle",
  props: {
    icon: String,
  },
};
</script>
<style lang="scss" scoped>
h1, h2, h3, h4 {
  font: inherit;
}

</style>
